/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Funding Rate DTO.
 */
export interface FundingRateRegisterDto {
  symbol?: string;
  fundingRate?: number;
  timestamp?: string;
}
